import { QueryParameters, SearchResponse } from '@/api/fleet-tracking/types';
import { fleetTrackingServiceClient as client } from '@/api/fleet-tracking/fleetTrackingServiceClient';

async function GetReferenceData(routeQueryParameters: QueryParameters): Promise<SearchResponse[]> {
  try {
    const response = await client.get<SearchResponse[]>('/api/v1/search', {
      params: routeQueryParameters
    });

    return response.data;
  } catch (error) {
    Promise.reject(error);
    return [];
  }
}

export default {
  GetReferenceData
};
